// = require angular-resource/angular-resource.min.js
// = require devex/angular/request_transformers

angular.module('models.bookmarkedSearch', ['ngResource'])
  .factory('BookmarkedSearch', ['$resource', function($resource) {
    return $resource('/api/public/current_user/bookmarked_searches/:id', {id: '@id'} , {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: [
          angular.fromJson,
          devex.angular.requestTransformers.pluckData
        ]
      },
      activateAlert: {
        method: 'POST',
        url: '/api/alerts'
      },
      updateAlert: {
        method: 'PATCH',
        url: '/api/alerts/:alert_id'
      },
      updateBookmarkSearch: {
        method: 'PATCH',
        url: '/api/public/current_user/bookmarked_searches/:id',
        transformResponse: [angular.fromJson]
      },
      deleteAlert: {
        method: 'DELETE',
        url: '/api/alerts/:alert_id'
      }
    });
  }]);
